import React, { useEffect, useState } from 'react';
import { api } from '../App';
import { workspaceError } from '../contexts/WorkspaceContext';
import { Button } from './ui/button';

const blockers = {
  administrator_profile: 'No se permite eliminar un perfil administrador con esta herramienta.',
  legacy_groups: 'Hay grupos antiguos de reparto que requieren reconciliación.',
  pending_board_operations: 'Hay operaciones de tablero pendientes de revisión.',
  pending_profile_operation: 'Hay una operación del perfil interrumpida o en curso.',
  orphan_financial_data: 'Hay registros sin un tablero reconocido; deben revisarse primero.',
};

export default function WorkspaceLifecyclePreview({ owner }) {
  const [action, setAction] = useState('reset');
  const [impact, setImpact] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [requested, setRequested] = useState(null);
  useEffect(() => { setRequested(null); setImpact(null); setError(''); setLoading(false); }, [owner, action]);
  useEffect(() => {
    let current = true;
    if (!owner || !requested || requested.owner !== owner || requested.action !== action) return;
    setLoading(true); setImpact(null); setError('');
    api.get(`/admin/workspace-operations/profiles/${owner}/lifecycle`, { params: { action } })
      .then(({ data }) => { if (current) setImpact(data); })
      .catch(e => { if (current) setError(workspaceError(e)); })
      .finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [owner, action, requested]);
  if (!owner) return null;
  return <section className="space-y-3 rounded border p-3" aria-label="Mantenimiento del perfil">
    <h4 className="font-semibold">Revisar reinicio o eliminación del perfil</h4>
    <p className="text-sm text-slate-600">Esta vista solo consulta el impacto. La ejecución se realiza con la herramienta administrativa y los procesos detenidos.</p>
    <label className="block text-sm">Operación a revisar<select aria-label="Operación a revisar" className="mt-1 w-full rounded border p-2" value={action} onChange={e => setAction(e.target.value)}>
      <option value="reset">Reiniciar finanzas de todos sus tableros</option><option value="delete">Eliminar perfil y todos sus tableros</option>
    </select></label>
    <Button variant="outline" disabled={loading} onClick={() => setRequested({ owner, action })}>Consultar impacto</Button>
    {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
    {impact && <div role="status" className="space-y-2 text-sm">
      {impact.boards && <><p>{impact.boards.length} tableros propios, incluidos los archivados: {impact.boards.map(b => b.name).join(', ')}.</p>
        <p>{impact.memberships_in_owned_boards} accesos compartidos y {impact.invitations_in_owned_boards} invitaciones en sus tableros.</p>
        <p>{Object.values(impact.records || {}).reduce((sum, count) => sum + count, 0)} registros financieros y de conversación asociados al propietario.</p>
        <p>{action === 'reset' ? 'El reinicio conserva perfil, suscripción, tableros y miembros. Crea copias previas y cierra sus sesiones.' : 'La eliminación borra sus tableros, copias e identidad y retira sus accesos e invitaciones a otros tableros.'} Las finanzas de otros propietarios se conservan.</p></>}
      {impact.blockers?.map(code => <p key={code} className="text-amber-800">{blockers[code] || code}</p>)}
      {impact.pending_operation && <p className="break-all">Operación pendiente: {impact.pending_operation.operation_id}</p>}
    </div>}
  </section>;
}
